import script from "./inquiryTab.vue?vue&type=script&setup=true&name=inquiryTab&lang=js"
export * from "./inquiryTab.vue?vue&type=script&setup=true&name=inquiryTab&lang=js"

const __exports__ = script;

export default __exports__